import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders } from '@angular/compiler/src/core';

import { ChartsModule } from 'ng2-charts/ng2-charts';

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

//ngx-bootstrap
import {
  BsDropdownModule,
  TabsModule,
  ButtonsModule,
  ModalModule,
  CarouselModule,
  PopoverModule,
  CollapseModule,
  AlertModule,
  ProgressbarModule, 
  BsDatepickerModule,
  TypeaheadModule 
} from 'ngx-bootstrap';

// angular material
import {
  MatExpansionModule,
  MatFormFieldModule,
  MatInputModule,
  MatTooltipModule,
  MatProgressSpinnerModule,
  MatIconModule,
  MatButtonModule,
  MatTabsModule,
  MatListModule,
  MatCardModule,
  MatToolbarModule,
  MatStepperModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatCheckboxModule,
  MatSelectModule,
  MatMenuModule,
  MatDialogModule,
  MatButtonToggleModule,
  MatTableModule,
  MatPaginatorModule,
  MatChipsModule,
  MatSlideToggleModule,
  MatOptionModule
} from '@angular/material';

import { NgxMaskModule, IConfig } from 'ngx-mask';

import { SelectDropDownModule } from 'ngx-select-dropdown'

import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { LevelerGuard } from './guards/leveler.guard';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ModalLoadingComponent } from './components/modals/modal-loading/modal-loading.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { ModalsAlertComponent } from './components/modals/modals-alert/modals-alert.component';
import { ModalReceivedStudentComponent } from './components/modals/modal-received-student/modal-received-student.component';
import { ModalStudentAttendance } from './components/modals/modal-student-attendance/modal-student-attendance.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ModalAddAvatarComponent } from './components/modals/modal-add-avatar/modal-add-avatar.component';

import { DxTreeListModule, DxSchedulerModule } from 'devextreme-angular';
import { ModalsAddCardSuccessComponent } from './components/modals/modals-add-cart-success/modals-add-cart-success.component';

export var options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    ModalLoadingComponent,
    TimelineComponent,
    ModalsAlertComponent,
    ModalReceivedStudentComponent,
    ModalStudentAttendance,
    SpinnerComponent,
    ModalsAddCardSuccessComponent,
    ModalAddAvatarComponent
  ],
  imports: [    
    CommonModule,
    FormsModule,    
    ReactiveFormsModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),    
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatCardModule,
    MatListModule,
    MatToolbarModule,
    MatStepperModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSelectModule,
    MatMenuModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatTableModule,
    MatPaginatorModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatOptionModule,
    ChartsModule,
    PerfectScrollbarModule,
    ChartsModule,
    ButtonsModule.forRoot(),
    NgxMaskModule.forRoot(options),     
    SelectDropDownModule,
    CarouselModule.forRoot(),
    PopoverModule.forRoot(),
    CollapseModule.forRoot(),
    AlertModule.forRoot(),
    ProgressbarModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DxTreeListModule,  
    DxSchedulerModule,
    TypeaheadModule.forRoot()
  ],
  exports: [
    CommonModule,    
    FormsModule,
    ReactiveFormsModule,
    AppAsideModule,
    AppBreadcrumbModule,
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    BsDropdownModule,
    TabsModule,
    ModalModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatCardModule,
    MatListModule,
    MatToolbarModule,
    MatStepperModule,
    MatAutocompleteModule,
    MatRadioModule,    
    MatCheckboxModule,
    MatSelectModule,
    MatMenuModule,
    MatDialogModule,
    MatChipsModule,
    MatSlideToggleModule,
    ChartsModule,
    PerfectScrollbarModule,
    ButtonsModule,
    NgxMaskModule,
    MatButtonToggleModule,
    MatTableModule,
    MatPaginatorModule,
    MatOptionModule,
    SelectDropDownModule,
    CarouselModule,
    PopoverModule,
    CollapseModule,
    AlertModule,
    TimelineComponent,
    DxTreeListModule,
    DxSchedulerModule,
    BsDatepickerModule,
    SpinnerComponent,
    ProgressbarModule,
    TypeaheadModule
  ],
  entryComponents: [
    ModalLoadingComponent,
    ModalsAlertComponent,
    ModalReceivedStudentComponent,
    ModalStudentAttendance,
    ModalsAddCardSuccessComponent,
    ModalAddAvatarComponent
  ]
})
export class SharedModule {
  static root(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        AuthGuard,    
        RoleGuard,    
        LevelerGuard,
        {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
      ]
    }
  }
}

